import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExecutionHistoryService {

  constructor(private http: HttpClient) { }

  getMyProjectList() {
    return this.http.get<any>(`${environment.apiUrl}users/myProjects`);
  }

  getUsersList() {
    return this.http.get<any>(`${environment.apiUrl}users`);
  }

  getTestCaseResultsList(searchParams) {
    return this.http.post<any>(`${environment.apiUrl}result/testCases`, searchParams);
  }

  getTestSuiteResultsList(searchParams) {
    return this.http.post<any>(`${environment.apiUrl}result/testSuite`, searchParams);
  }

  getMasterSuiteResultsList(searchParams) {
    return this.http.post<any>(`${environment.apiUrl}result/masterSuite`, searchParams);
  }

  readTestcasesResult(testCaseId) {
    return this.http.get<any>(`${environment.apiUrl}result/testCases/${testCaseId}/endPointShortData`)
  }

  getExecutionHistory(searchParams:any) {
    return this.http.post<any>(`${environment.apiUrl}executions/result`,searchParams);
  }
}